import { styled } from '@mui/material';
import { bottom } from '@popperjs/core';

export const StyledFormFooter = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  paddingBottom: '2rem',
}));
